import ChannelCession from "assets/img/svg/ChannelCession";
import ChannelCollective from "assets/img/svg/ChannelCollective";
import ChannelNumerique from "assets/img/svg/ChannelNumerique";
import ChannelOther from "assets/img/svg/ChannelOther";
import ChannelPhysique from "assets/img/svg/ChannelPhysique";
import { ChannelKind } from "containers/Channels";
import type { CSSProperties } from "react";

interface IChannelIcon {
    channelKind: number;
    color?: string;
    sx?: CSSProperties;
    height?: string;
    width?: string;
}

const ChannelIcon = ({ channelKind, color, sx, height, width }: IChannelIcon) => {
    return (
        <div style={{ ...sx, display: "flex", width: "max-content", height: "max-content" }}>
            {channelKind === ChannelKind.PHYSICAL ? (
                <ChannelPhysique color={color} height={height} width={width} />
            ) : channelKind === ChannelKind.DIGITAL ? (
                <ChannelNumerique color={color} height={height} width={width} />
            ) : channelKind === ChannelKind.RIGHTS_TRANSFER ? (
                <ChannelCession color={color} height={height} width={width} />
            ) : channelKind === ChannelKind.COLLECTIVE_MANAGEMENT ? (
                <ChannelCollective color={color} height={height} width={width} />
            ) : (
                channelKind === ChannelKind.OTHER && <ChannelOther color={color} height={height} width={width} />
            )}
        </div>
    );
};

export default ChannelIcon;
